var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.name],domProps:{"innerHTML":_vm._s(_vm.practice)}})
}
var staticRenderFns = []

export { render, staticRenderFns }